import { APIAdapter } from "../../../helpers/api_helper";
import axios from "axios";

const api = new APIAdapter();

const transaction = process.env.REACT_APP_API_TRANSACTION;
const currentUser = JSON.parse(sessionStorage.getItem("authUser"));

export const addReversement = async (data, selectedBusiness) => {
  try {
    const response = await api.create(`${transaction}/transfer/create/${data?.merchantId}`, data,
      {
        headers: {
          Authorization: `Bearer ${currentUser?.token}`,
          "x-api-key": selectedBusiness?.apiKey,
          "X-API-TOKEN": selectedBusiness?.apiToken,
        },
      }
    );
    
    return response;
  } catch (error) {
    throw error;
  }
};

export const addReversementMass = async (selectedBusiness, data ) => {
  try {
    const response = await axios.post(`${transaction}/transaction/pay-out-mass`, data,
      {
        headers: {
          Authorization: `Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJUZXN0Iiwicm9sZXMiOlsiQVBQIl0sImlhdCI6MTc3MDY0ODQzNH0.D--ssAjRAO6XqjwCBAj-2HL9oOQAxrHMFEaPwSHXtTfhODM4Mr6TlQtIzH5A65eyrubJg10bqFIZ6cXnEClmAg`,
          "x-api-key": selectedBusiness?.apiKey,
          "X-API-TOKEN": selectedBusiness?.apiToken,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getReversement = async (businessId) => {
  try {
    const response = axios.get(`${transaction}/transfer/all/${businessId}`,
      {
        headers: {
          Authorization: `Bearer ${currentUser?.token}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateReversement = async (id, data) => {
  try {
    const response = await axios.put(`${transaction}/subscriptions/update/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteReversement = async (id, token) => {
  try {
    const response = await axios.delete(`${transaction}/subscriptions/delete/${id}`,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

  export const getBusinessByMarchandId = async (merchandId) => {
    try {
      const response = await api.get(`/developer-accounts/merchant/${merchandId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };